import { createStore } from "vuex";
import App from './modules/app';
import Blog from './modules/blog';

export default createStore({
	modules: {
		App,
		Blog
	}
});
